module.exports = __webpack_public_path__ + "img/logo.668ab4fb.png";